module.exports = __webpack_public_path__ + "img/tax.a88351d7.svg";